import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import DjangoMessages from 'components/DjangoMessages';
import FormHeader from 'components/Form/FormHeader';
import {useBackend} from 'state/backend';
import EmailAddresses from './EmailAddresses';
import NotificationAddresses from './NotificationAddresses';
import {ProfileEmailSettingsBackend} from './types';

const EmailSettings: FC = () => {
    const {data} = useBackend<ProfileEmailSettingsBackend>();
    const {t} = useTranslation('Profile.EmailSettings');

    return (
        <div className="max-w-5xl">
            <DjangoMessages className="mb-4" />
            <FormHeader className="mb-8" hideHR={true} title={t('formTitle')} />
            <EmailAddresses
                emails={data.emails}
                isSfConnected={data.isSfConnected}
            />
            <NotificationAddresses
                emails={data.emails}
                notificationAddresses={data.employees}
            />
        </div>
    );
};

export default EmailSettings;
